/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `watchface_settings` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class WatchfaceSettingsMesg : Mesg {
    public constructor() : super("WatchfaceSettings", Profile.MesgNum.WATCHFACE_SETTINGS)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** mode. */
    public var mode: WatchfaceMode?
        get() = (getFieldValue(MODE_FIELD_NUM) as? UByte)?.let { WatchfaceMode.fromValue(it) }
        set(value) = setFieldValue(MODE_FIELD_NUM, value?.value)

    /** layout. */
    public var layout: UByte?
        get() = getFieldValue(LAYOUT_FIELD_NUM) as? UByte
        set(value) = setFieldValue(LAYOUT_FIELD_NUM, value)

    /**
     * digital_layout: what layout means when this message selects it.
     */
    public val digitalLayout: DigitalWatchfaceLayout?
        get() = (getFieldValue(LAYOUT_FIELD_NUM, 0, SubFieldSelector.Named("DigitalLayout")) as? UByte)?.let { DigitalWatchfaceLayout.fromValue(it) }

    public fun setDigitalLayout(value: DigitalWatchfaceLayout?) {
        setFieldValue(LAYOUT_FIELD_NUM, value?.value, 0, SubFieldSelector.Named("DigitalLayout"))
    }

    /**
     * analog_layout: what layout means when this message selects it.
     */
    public val analogLayout: AnalogWatchfaceLayout?
        get() = (getFieldValue(LAYOUT_FIELD_NUM, 0, SubFieldSelector.Named("AnalogLayout")) as? UByte)?.let { AnalogWatchfaceLayout.fromValue(it) }

    public fun setAnalogLayout(value: AnalogWatchfaceLayout?) {
        setFieldValue(LAYOUT_FIELD_NUM, value?.value, 0, SubFieldSelector.Named("AnalogLayout"))
    }

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val MODE_FIELD_NUM: UByte = 0u
        public const val LAYOUT_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("Mode", 0u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[1] = Field("Layout", 1u, BaseType.BYTE, 1.0, 0.0, "", false)
                .addSubField(
                    SubField("DigitalLayout", BaseType.ENUM, 1.0, 0.0, "").also { subField ->
                        subField.addMap(0u, 0)
                    },
                )
                .addSubField(
                    SubField("AnalogLayout", BaseType.ENUM, 1.0, 0.0, "").also { subField ->
                        subField.addMap(0u, 1)
                    },
                )
            return fields
        }
    }
}
